(function () {
  'use strict';

  var locale = (document.documentElement.lang || '').toLowerCase().split('-')[0];

  if (locale === 'he' || ['en', 'ar', 'ru'].indexOf(locale) === -1) return;

  function isVariantForm(form) {
    return !!form.querySelector('select[name="id"], input[name="id"], select[name="id[]"]');
  }

  function isLocalizedAddAction(form) {
    var action = form.getAttribute('action') || '';
    return new RegExp('^/' + locale + '/cart/add(?:[?#]|$)', 'i').test(action);
  }

  function normalizeProductForm() {
    var scope = document.querySelector('main') || document.body;
    var forms = scope.querySelectorAll('form');

    for (var index = 0; index < forms.length; index += 1) {
      var form = forms[index];

      if (isVariantForm(form) && isLocalizedAddAction(form)) {
        form.setAttribute('action', '/cart/add');
        form.setAttribute('data-vp-wod-form-normalized', 'true');
        break;
      }
    }
  }

  function start() {
    normalizeProductForm();

    new MutationObserver(normalizeProductForm).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['action']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();